import React, { useState, useEffect, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";
import LoadingSpinner from "../../../components/Loader/LoadingSpinner";
import { LazyLoadImage } from "react-lazy-load-image-component";
import API_UTIL from "../../../services/AuthIntereptor";
import Footer from "../../../components/Footer/Footer";
import MergeDuplicateUsers from "./MergeHandler/MergeDuplicateUsers";
import "./Pro.css";
import AppBar from "../../../components/AppBar/AppBar";
import Modal from "react-modal";
import { toast } from "react-toastify";
import { Icons, Button, ModalHeader } from "../../../components/ui";

function ProNew() {
  const { eventId } = useParams();
  const [eventDetails, setEventDetails] = useState(null); // New state for event details
  const [userThumbnails, setUserThumbnails] = useState([]);
  const [clientDetails, setClientDetails] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const username = localStorage.getItem("username");
  const [isLoading, setIsLoading] = useState(true);
  const [fetchTimeout, setFetchTimeout] = useState(false);
  const isDataFetched = useRef(false);
  const [showMergeDuplicateUsers, setShowMergeDuplicateUsers] = useState(false);
  const [mergeMode, setMergeMode] = useState(false);
  const [mergeMessage, setMergeMessage] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [showMergePopup, setShowMergePopup] = useState(false);
  const [selectedMainUser, setSelectedMainUser] = useState(null);
  const [selectedDuplicateUsers, setSelectedDuplicateUsers] = useState([]);
  const [showRewardPointsPopUp, setShowRewardPointsPopUp] = useState(null);
  const [rewardPoints, setRewardPoints] = useState();
  const [isSendModalOpen, setIsSendModalOpen] = useState(false);
  const location = useLocation();
  const [isSending, setIsSending] = useState(false);
  const [isImageProcessingDone, setIsImageProcessingDone]  = useState(true);
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);

  // const event = location.state?.event;

  const handleClick = (item) => {
    if (mergeMode) {
      handleThumbnailClick(item);
    } else {
      saveShareDetails(item);
      shareOnWhatsApp(item);
    }
  };

  // New function to fetch event details
  const fetchEventDetails = async () => {
    try {
      const response = await API_UTIL.get(`/getEventDetails/${eventId}`);
      if (response.status === 200) {
        setEventDetails(response.data); // Set event details in state
        if( response.data.uploaded_files === response.data.files_indexed){
          if(isImageProcessingDone === false)
            fetchThumbnails()
          setIsImageProcessingDone(true);
        }
        else{
            setIsImageProcessingDone(false);

        }
      } else {
        throw new Error("Failed to fetch event details");
      }
    } catch (error) {
      console.error("Error fetching event details:", error);
    }
  };

  const handleManageUsers = () => {
    setMergeMode(true);
    setSelectedUsers([]);
  };

  const handleCancelManageUsers = () => {
    setMergeMode(false);
    setShowMergePopup(false);
    setSelectedUsers([]);
    setMergeMessage("");
  };

  const handleClosePopup = (fullReset = false) => {
    setShowMergePopup(false);
    if (fullReset) {
      setMergeMode(false);
      setSelectedUsers([]);
    } else {
      setSelectedUsers((prev) => prev.slice(0, 1));
    }
  };

  const handleMergeClick = () => {
    if (!isImageProcessingDone) {
      setIsWarningModalOpen(true); // Show warning if images are still processing
    }else{
      setMergeMessage("Select 2 duplicate faces to merge");
      setShowMergeDuplicateUsers(true);
      setMergeMode(true);
      setSelectedMainUser(null);
      setSelectedDuplicateUsers([]);
    }
  };

  const handleMerge = async (reason) => {
    try {
      const user_phone_number = localStorage.getItem("userPhoneNumber");
      const response = await API_UTIL.post("/mergeUsers", {
        userIds: selectedUsers.map((u) => u.user_id),
        reason: reason,
        eventId: eventId,
        user_phone_number: user_phone_number,
      });

      if (response.data.success) {
        updateRewardPoints(50);
        await fetchThumbnails();
      }
      return response.data;
    } catch (error) {
      console.error("Error merging users:", error);
      return { success: false, message: "Error merging users. Please try again." };
    }
  };

  const handleThumbnailClick = (user) => {
    if (!mergeMode) return;

    setSelectedUsers((prev) => {
      const isSelected = prev.some((u) => u.user_id === user.user_id);
      if (isSelected) {
        return prev.filter((u) => u.user_id !== user.user_id);
      } else if (prev.length < 2) {
        const newSelected = [...prev, user];
        if (newSelected.length === 2) {
          setShowMergePopup(true);
        }
        return newSelected;
      }
      return prev;
    });
  };

  const shareOnWhatsApp = (item) => {
    const userId = item.user_id;
    const count = item.count;
    const text = `*Greetings*,\nWe have discovered your *${count}* images captured during the event *"${eventDetails?.event_name}"*.\nKindly proceed to the provided URL to access and view your photographs:\nhttps://imageshield.ai/photosV1/${eventDetails?.folder_name}/${userId}\n\nCheers,\n*Flashback*`;
    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`;
    window.open(whatsappUrl, "_blank");
  };

  const saveShareDetails = async (item) => {
    try {
      const user = localStorage.userPhoneNumber;
      const response = await API_UTIL.post(`/saveProShareDetails`, {
        user: user,
        sharedUser: item.user_id,
        event_id: eventId,
      });
      if (response.status === 200) {
        updateRewardPoints(10);
      } else {
        throw new Error("Failed to save share info");
      }
    } catch (error) {
      console.error("Error saving share details:", error);
    }
  };

  const fetchThumbnails = async () => {
    if (userThumbnails.length === 0) setIsLoading(true);

    try {
      const response = await API_UTIL.get(`/userThumbnailsByEventId/${eventId}`);
      if (response.status === 200) {
        setUserThumbnails(response.data);
        fetchClientDetails();
      } else {
        throw new Error("Failed to fetch user thumbnails");
      }
    } catch (error) {
      console.error("Error fetching user thumbnails:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchClientDetails = async () => {
    if (userThumbnails.length === 0) setIsLoading(true);

    try {
      const response = await API_UTIL.get(`/userThumbnailsByEventId/${eventId}`);
      if (response.status === 200) {
        setClientDetails(response.data);
        fetchuserDetails();
      } else {
        throw new Error("Failed to fetch client Details");
      }
    } catch (error) {
      console.error("Error fetching user thumbnails:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchuserDetails = async () => {
    if (userThumbnails.length === 0) setIsLoading(true);

    try {
      const response = await API_UTIL.get(`/getUserDetails/${localStorage.userPhoneNumber}`);
      if (response.status === 200) {
        setUserDetails(response.data);
      } else {
        throw new Error("Failed to fetch client Details");
      }
    } catch (error) {
      console.error("Error fetching user thumbnails:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const sendWhatsappMsg = async () => {
    try {
      const userIdMappingResponse = await API_UTIL.post("/generateUserIdsForExistingUsers", {
        eventName: eventDetails?.folder_name,
      });
      if (userIdMappingResponse.status === 200) {
        const sendFlashbacksResponse = await API_UTIL.post("/send-flashbacks", {
          eventName: eventDetails?.folder_name,
        });

        if (sendFlashbacksResponse.status === 200) {
          toast.success("Flashbacks sent successfully!");
        } else {
          throw new Error("Failed to send flashbacks.");
        }
      } else {
        throw new Error("Failed to send flashbacks.");
      }
    } catch (error) {
      console.error("Error Publishing Images", error);
      toast.error("Failed to Publish Images");
    }
  };

  const handleSendPhotos = async () => {
    if (!isImageProcessingDone) {
      setIsWarningModalOpen(true); // Show warning if images are still processing
    } else {
      setIsSending(true);
      setIsSendModalOpen(true);
      try {
        await sendWhatsappMsg();
      } finally {
        setIsSending(false);
      }
    }
  };
  const closeWarningModal = () => {
    setIsWarningModalOpen(false);
  };

  const closeSendPhotos = () => {
    setIsSendModalOpen(false);
  };

  const updateRewardPoints = async (points) => {
    const updateData = {
      user_phone_number: localStorage.userPhoneNumber,
      reward_points: userDetails?.reward_points ? userDetails.reward_points + points : 50 + points,
    };

    try {
      const response = await API_UTIL.post("/updateUserDetails", updateData);
      if (response.status === 200) {
        setRewardPoints(points);
        setShowRewardPointsPopUp(true);
        setUserDetails(response.data.data);
      } else {
        console.log("Failed to update user details. Please try again.");
      }
    } catch (error) {
      console.error("Error updating user details:", error);
    }
  };

  // Polling for event details every 5 seconds
  useEffect(() => {
    fetchEventDetails(); // Fetch event details initially

    const interval = setInterval(() => {
      fetchEventDetails(); // Fetch event details every 5 seconds
    }, 30000);

    return () => clearInterval(interval); // Clean up interval on component unmount
  }, [eventId]);

  useEffect(() => {
    if (isDataFetched.current) return;
    fetchThumbnails();
    isDataFetched.current = true;
  }, []);

  // Separate registered and unregistered users
  const registeredUsers = userThumbnails.filter((thumbnail) => thumbnail.is_registered);
  const unregisteredUsers = userThumbnails.filter((thumbnail) => !thumbnail.is_registered);

  const renderFaceTile = (item, index) => {
    const isSelected = selectedUsers.some((u) => u.user_id === item.user_id);
    return (
      <div
        key={index}
        className={`relative aspect-square rounded-lg overflow-hidden border bg-gray-50 cursor-pointer transition group ${
          isSelected
            ? "border-brand-600 ring-2 ring-brand-500/40"
            : "border-gray-200 hover:border-brand-200"
        }`}
        onClick={() => handleClick(item)}
      >
        <LazyLoadImage src={item.face_url} alt={`User ${index + 1}`} className="w-full h-full object-cover" />
        <span className="absolute bottom-0 left-0 right-0 bg-slate-900/80 text-white text-[11px] font-semibold text-center py-1">
          {item.count}
        </span>
        {mergeMode && (
          <div
            className={`absolute top-1.5 right-1.5 w-6 h-6 grid place-items-center rounded-full text-xs font-bold transition ${
              isSelected ? "bg-brand-600 text-white" : "bg-white/90 text-slate-400 border border-gray-200"
            }`}
          >
            ✓
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <AppBar />
          <div className="fade-in flex-1 max-w-[1400px] w-full mx-auto px-4 sm:px-6 py-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-6">
              <div className="flex items-center gap-2">
                {!mergeMode ? (
                  <Button variant="secondary" icon={Icons.Users} onClick={handleMergeClick}>
                    Manage Faces
                  </Button>
                ) : (
                  <Button variant="secondary" icon={Icons.X} onClick={handleCancelManageUsers}>
                    Cancel
                  </Button>
                )}
                <Button icon={Icons.Send} onClick={handleSendPhotos} disabled={isSending}>
                  {isSending ? "Sending..." : "Send Photos"}
                </Button>
              </div>
              <div className="bg-white border border-gray-200 rounded-xl px-4 py-2.5 shadow-card">
                <span className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                  Total Attendees
                </span>
                <span className="ml-2 text-lg font-bold text-slate-900">{userThumbnails.length}</span>
              </div>
            </div>

            {!isImageProcessingDone && (
              <div className="mb-5 rounded-xl border border-amber-200 bg-amber-50 text-amber-800 text-sm px-4 py-3">
                Some of the images are still being processed. Stay tuned for updates.
              </div>
            )}

            {mergeMessage && (
              <div className="mb-5 rounded-xl border border-brand-100 bg-brand-50 text-brand-700 text-sm px-4 py-3">
                {mergeMessage}
              </div>
            )}

            {userThumbnails.length > 0 ? (
              <>
                <h2 className="text-lg font-bold text-slate-900 mb-3">Registered Users</h2>
                <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-3 mb-8">
                  {registeredUsers.map((item, index) => renderFaceTile(item, index))}
                </div>

                <h2 className="text-lg font-bold text-slate-900 mb-3">Unregistered Users</h2>
                <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-3">
                  {unregisteredUsers.map((item, index) => renderFaceTile(item, index))}
                </div>
              </>
            ) : fetchTimeout ? (
              <p className="text-slate-500 text-sm">No images to display</p>
            ) : (
              <p className="text-slate-500 text-sm">Failed to load images</p>
            )}
          </div>
          <Footer />
        </>
      )}

      {showMergePopup && (
        <MergeDuplicateUsers users={selectedUsers} onClose={handleCancelManageUsers} onMerge={handleMerge} />
      )}

      {isWarningModalOpen && (
        <Modal
          isOpen={isWarningModalOpen}
          onRequestClose={closeWarningModal}
          contentLabel="Warning"
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] max-w-md bg-white rounded-2xl shadow-card outline-none z-[1000]"
          overlayClassName="fixed inset-0 bg-black/60 z-[999]"
        >
          <ModalHeader title="Please wait" onClose={closeWarningModal} />
          <div className="p-5 text-sm text-slate-600 leading-relaxed">
            Some of the images are still being processed. Please wait until processing is complete.
          </div>
        </Modal>
      )}

      {isSendModalOpen && (
        <Modal
          key={isSendModalOpen ? "open" : "closed"} // Adding key to handle unique modal instances
          isOpen={isSendModalOpen}
          onRequestClose={closeSendPhotos}
          contentLabel="Send Photos"
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] max-w-md bg-white rounded-2xl shadow-card outline-none z-[1000]"
          overlayClassName="fixed inset-0 bg-black/60 z-[999]"
        >
          <ModalHeader title="Send Photos" onClose={closeSendPhotos} />
          <div className="p-5 text-sm text-slate-600 leading-relaxed space-y-2">
            <p>Only registered users will receive Photos.</p>
            <p>
              For unregistered users, you can click on their thumbnail and send photos through your WhatsApp.
            </p>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default ProNew;
